import {
  BaseEdge,
  getBezierPath,
  useReactFlow,
  type EdgeProps,
} from '@xyflow/react';
import { useEffect } from 'react';

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  selected,
}: EdgeProps) {
  const { setEdges } = useReactFlow();
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  useEffect(() => {
    const thisEdgeListener = (keyboardEvent: KeyboardEvent) => {
      if (keyboardEvent.key === "Delete") {
        setEdges((edges) => edges.filter((edge) => edge.id !== id));
      }
    }

    if (selected) {
      window.addEventListener('keydown', thisEdgeListener);
    }

    return () => {
      window.removeEventListener('keydown', thisEdgeListener);
    }
  }, [selected])

  return (
    <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
  );
}
